// extracted by mini-css-extract-plugin
export default {"songs":"Songs_songs__DAv2q"};